<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title class="pt-0 pl-0 pr-0">
            <v-combobox
              v-model="currentVersion"
              :items="changelog"
              item-text="version"
              prepend-inner-icon="mdi-text-box-search-outline"
              :label="$t('changelog.version')"
              return-object
              filled
              hide-details
            />
          </v-card-title>
          <template v-if="currentVersion != null">
            <v-card-subtitle
              id="publish-area"
              class="pt-4"
            >
              <span>
                {{ $t("changelog.published") }}
              </span>
              <v-chip
                label
                outlined
                ripple
              >
                <v-icon
                  left
                  small
                >
                  mdi-calendar
                </v-icon>
                <span>
                  {{ formatDate(currentVersion.date) }}
                </span>
              </v-chip>
            </v-card-subtitle>
            <v-divider />
            <v-card-text v-if="currentVersion.function.length > 0">
              <h4>
                <v-icon left>mdi-creation-outline</v-icon>
                <span>
                  {{ $t("changelog.new-functions") }}
                </span>
              </h4>
              <ul>
                <li
                  v-for="(val, index) in currentVersion.function"
                  :key="index"
                >
                  {{ val }}
                </li>
              </ul>
            </v-card-text>
            <v-card-text v-if="currentVersion.upgrade.length > 0">
              <h4>
                <v-icon left>mdi-arrow-up-bold-circle-outline</v-icon>
                <span>
                  {{ $t("changelog.upgrades") }}
                </span>
              </h4>
              <ul>
                <li
                  v-for="(val, index) in currentVersion.upgrade"
                  :key="index"
                >
                  {{ val }}
                </li>
              </ul>
            </v-card-text>
            <v-card-text v-if="currentVersion.fix.length > 0">
              <h4>
                <v-icon left>mdi-bug-check</v-icon>
                <span>
                  {{ $t("changelog.bug-fixes") }}
                </span>
              </h4>
              <ul>
                <li
                  v-for="(val, index) in currentVersion.fix"
                  :key="index"
                >
                  {{ val }}
                </li>
              </ul>
            </v-card-text>
          </template>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Libs
const moment = require("moment");

export default {
  data() {
    return {
      changelog: [
        {
          version: "v1.0.17 (last)",
          date: "2025-07-18",
          fix: [
            "Création : Correction du widget météo pour afficher l'humidité.",
            "Médiathèque : Maintenant les dossiers ne peuvent plus terminer et commencer par des espaces et/ou des points.",
            "Planification : Correction d'un problème de redimensionnement de la prévisualisation de la planification.",
          ],
          function: [
            "Ajout d'un module de modèle de projet.",
            "Création : Ajout des animations sortantes pour les widgets.",
            "Player : Ajout des animations sortantes pour les widgets.",
          ],
          upgrade: [
            "Les fenêtres de dialogue sont maintenant moins intrusives et disparaissent automatiquement après 5 secondes.",
            "Planification : Lorsqu'un projet a changé de nom ou d'emplacement sur le disque, il est maintenant indiqué dans la planification et une fenêtre permet de restaurer le lien.",
            "Player : Les statistiques sont maintenant optionnelles par défaut elles sont activées. (une demande auprès de DisplayMedia est nécessaire pour les désactiver)",
          ],
        },
        {
          version: "v1.0.16",
          date: "2025-02-13",
          fix: [
            "Planification : Correction d'un problème lorsque l'on ajoutait plusieurs projets en une seule fois.",
            "Droits : Correction d'un problème où l'affichage des droits d'accès sur un utilisateur n'était pas en accord avec la base de données.",
            "Droits : Correction d'un problème où un utilisateur pouvait voir des dossiers dont il n'avait pas les accès.",
          ],
          function: [
            "Création : Ajout des animations entrantes pour les widgets.",
            "Player : Ajout des animations entrantes pour les widgets.",
          ],
          upgrade: [
            "Médiathèque : Drag & Drop ajouté pour déplacer les fichiers.",
            "Médiathèque : Sélection multiple avec Ctrl & Shift.",
            "Médiathèque : Miniature de projet maintenant sauvegardé hors de la base de données.",
            "Planification : Modification du temps d'affichage d'un projet directement sur la page.",
          ],
        },
        {
          version: "v1.0.15",
          date: "2024-12-11",
          fix: [
            "Création : Lors de l'ouverture d'un projet les zones comportant des rotations ne sont pas reconstituées fidèlement.",
            "Droits : Correction d'un problème où un utilisateur n'ayant pas le droit Profil pouvait accéder à la page par un autre moyen.",
            "Player : Correction d'un bug d'affichage sur le widget texte lorsqu'aucune police n'est définie.",
            "Player : Correction d'un bug qui empêchait l'actualisation de la planification lorsqu'un seul projet était actif.",
            "Player : Correction d'un bug qui affichait l'icône météo plusieurs fois lorsque plusieurs widget météo était présent dans le projet.",
          ],
          function: [
            "Planification : Ajout d'un calendrier pour avoir une représentation visuelle de la planification.",
          ],
          upgrade: [
            "Médiathèque : Clic droit dans la liste des dossiers pour ouvrir, coller, renommer et supprimer.",
            "Médiathèque : Coller un fichier dans un dossier directement en faisant le clic droit sur le dossier voulu.",
            "Profil : Fenêtre de confirmation lors de la création, modification d'un élément.",
            "Profil : Pouvoir changer son mot de passe utilisateur sans avoir le droit profil complet.",
          ],
        },
        {
          version: "v1.0.14",
          date: "2024-06-11",
          fix: ["Player : Correction d'un bug lors de l'affichage d'un seul projet sur une plage de temps donnée."],
          function: ["Changelog : Ajout de la page.", "Manuel : Ajout d'un bouton pour y accéder."],
          upgrade: [
            "Ajouts de plusieurs entrées dans le fichier de langue pour des messages d'erreur.",
            "Fichier d'icônes mis à jour.",
            "Police Roboto ajoutée dans l'application.",
            "Statut : Journal d'incident désactivé lorsque aucun player n'a de problème.",
          ],
        },
        {
          version: "v1.0.13",
          date: "2024-05-28",
          fix: [
            "Certains icônes n'apparraissaient pas aléatoirement.",
            "Profil : Correctif sur les droits utilisateurs.",
            "Profil : Correction d'un bug sur le changement de mot de passe.",
          ],
          function: [
            "Projet : Champ 'temps' (HH:MM:SS) pour la durée d'affichage.",
            "Médiathèque : limitation d'un utilisateur à un dossier spécifique.",
            "Planification : Fenêtre de confirmation lors de la fermeture de la page sans mise à jour des players.",
            "Planification : Ajout d'une icône pour les projets 'actifs'.",
            "Statut : Désactivation du journal d'incident en cas d'absence de problème avec les players.",
          ],
          upgrade: [
            "Ajout d'un ascenseur pour une meilleure navigation dans les listes.",
            "Création : Limitation du temps de projet à 24 heures maximum.",
            "Widget Calendrier : ajout de formats.",
            "Planification : Meilleur affichage du nom de projet.",
            "Planification : Animation sur l'icône de mise à jour lors d'une modification.",
            "Statistiques : optimisation.",
          ],
        },
        {
          version: "v1.0.12",
          date: "2023-12-22",
          fix: [
            "Projet : Correction d'un bug où les projet ne se sauvegardaient pas dans le dossier sélectionné.",
            "Projet : Correction d'un bug sur la durée d'affichage.",
          ],
          function: [],
          upgrade: ["Mise en place du protocole HTTPS."],
        },
        {
          version: "v1.0.11-weather",
          date: "2023-06-05",
          fix: [],
          function: [],
          upgrade: [
            "Widget météo : Changement de l'API météo d'OpenWeatherMap vers OpenMeteo.",
            "Widget météo : Ajout de la prévision jusqu'à 7 jours.",
          ],
        },
        {
          version: "v1.0.10",
          date: "2023-02-20",
          fix: [
            "Création : Correction sur la sauvegarde de projet qui modifiait le niveau de zoom du projet.",
            "Médiathèque : Correction de l'upload de fichier multiple qui pouvait créé un fichier blob.",
            "Médiathèque : Correction des miniatures dans la médiathèque qui ne se mettait pas à jour correctement.",
            "Médiathèque : Correction d'un bug qui pouvait empêcher l'apparition du dossier de partage dans la médiathèque.",
            "Player : Correction d'un bug sur le mode veille qui empêchait la fermeture de l'application sous certaines conditions.",
          ],
          function: [
            "Widget texte : Nouvel éditeur de texte permettant de modifier la police.",
            "Widget météo : Modification des couleurs des textes.",
            "Médiathèque : Ajout d'un menu contextuel.",
            "Médiathèque : Ajout des raccourcis clavier.",
            "Planification : Ajout de la prévisualisation",
          ],
          upgrade: [
            "Uniformisation des polices utilisées sur les widgets texte défilant et météo.",
            "Création : Optimisation de la page.",
            "Médiathèque : Possibilité d'uploader des projets dans la médiathèque.",
            "Planification : Suppression des projets périmés.",
          ],
        },
        {
          version: "v1.0.9",
          date: "2023-02-10",
          fix: [
            "Médiathèque : Correction d'un bug où l'explorateur de dossier ne se rafraichissait pas.",
            "Player : Correction d'un bug lors de la configuration du player qui pouvait apparaître lorsqu'aucune resolution et position n'était défini.",
          ],
          function: ["Profil : Possibilité de bloquer un utilisateur sur certains players spécifiques."],
          upgrade: ["Amélioration de la fenêtre d'ouverture de projet avec recherche et plus d'informations."],
        },
        {
          version: "v1.0.8",
          date: "2023-01-31",
          fix: [
            "Création : Correction d'un bug qui apparaissait lorsque l'on sortait de la fenêtre lors de la création d'un widget.",
            "Widget calendrier : Correction d'un bug.",
          ],
          function: ["Widget météo : Ajout du choix de la police sur le widget météo."],
          upgrade: ["Profil : Modification du fonctionnement de l'édition de la ville et du département des players."],
        },
        {
          version: "v1.0.7-stats",
          date: "2022-12-30",
          fix: ["Correction d'un bug sur le bouton de copie dans le presse-papier qui ne fonctionne pas hors HTTPS."],
          function: ["Statistique : Ajout du module."],
          upgrade: [
            "Administration : Enlève l'utilisation des caractère spéciaux dans la création des mots de passe aléatoires.",
          ],
        },
        {
          version: "v1.0.6",
          date: "2022-09-27",
          fix: [
            "Médiathèque : Correction d'un bug qui empêcher la fenêtre de prévisualisation d'image ou vidéo de s'ouvrir une fois fermer.",
          ],
          function: [
            "Création : Possibilité de modifier la durée d'affichage d'une image lors de la création d'un diaporama.",
          ],
          upgrade: [
            "Suppression du cache sur les fichiers utilisé lors de la création.",
            "Accueil : Changement de la fenêtre d'ouverture de projet sur la page d'accueil.",
            "Projet : Utilisation des fichiers contenu dans le projet en lieu et place de ceux contenu dans la médiathèque lors de l'ouverture.",
            "Médiathèque : Blocage de certaines fonctionnalités sur le dossier de partage.",
            "Médiathèque : Empêche un utilisateur de renommer, déplacer ou supprimer un projet en cours de planification.",
          ],
        },
        {
          version: "v1.0.5",
          date: "2022-07-21",
          fix: [
            "Création : Correction d'un bug où la création d'un widget sur un autre widget pouvait changer la position du widget dessous.",
            "Création : Correction d'un bug où la suppression dans un champs pouvait supprimer un widget.",
            "Planification : Correction d'un bug sur le bouton de filtrage des players.",
            "Player : Correction d'un bug concernant le mode veille de l'application.",
          ],
          function: [
            "Création : Ajout de l'onglet option.",
            "Projet : Possibilité de basculer en mode portrait ou paysage lors de la création d'un nouveau projet.",
            "Médiathèque : Ajout d'un dossier de partage visible par tous contenant des fichiers déjà créés.",
          ],
          upgrade: [
            "Prise en compte des erreurs et gestion de ces dernières pour éviter que l'application se bloque.",
            "Optimisation générale de l'application.",
            "Création : Nouvelle fenêtre de sélection de fichier pour widget image et vidéo.",
            "Médiathèque : Affichage d'une fenêtre lors de la réussite ou échec d'un upload.",
            "Profil : Ajout d'un retour utilisateur lors de la création ou modification.",
            "Player : Modification du fichier de config du player.",
          ],
        },
        {
          version: "v1.0.4",
          date: "2022-06-29",
          fix: ["Widget PDF : Correction d'un bug."],
          function: [],
          upgrade: [
            "Prise en compte des erreurs et gestion de ces dernières pour éviter que l'application se bloque.",
            "Médiathèque : Ajout de la couleur orange sur les badges des projets en cours de planification.",
            "Optimisation générale.",
          ],
        },
        {
          version: "v1.0.3",
          date: "2022-06-22",
          fix: [
            "Création : Correction d'un bug sur les champs dynamique de position et de taille de widget.",
            "Création : Suppression de l'onglet historique car non fonctionnel.",
            "Projet : Correction d'un bug sur la durée d'affichage.",
            "Projet : Correction d'un bug sur la sauvegarde.",
          ],
          function: [
            "Médiathèque : Ajout d'un badge sur la miniature des projets pour différencier un projet d'une image.",
          ],
          upgrade: [
            "Sauvegarde des paramètres de l'application dans le local storage.",
            "Création : Ajout d'une fenêtre lors de la sauvegarde d'un projet pour avertir si sauvegarde réussi ou non.",
            "Widget texte défilant : Amélioration.",
          ],
        },
        {
          version: "v1.0.2-critical",
          date: "2022-06-21",
          fix: [
            "Widget météo : Correction d'un bug critique qui pouvait bloquer l'application lorsque les icônes nuit de la météo étaient utilisés.",
          ],
          function: [],
          upgrade: [],
        },
        {
          version: "v1.0.1",
          date: "2022-06-16",
          fix: [
            "Widget texte : Editeur de texte corrigé.",
            "Widget PDF : Divers correctifs.",
            "Widget météo : Divers correctifs.",
          ],
          function: [],
          upgrade: [],
        },
        {
          version: "v1.0.0-rework",
          date: "2022-05-31",
          fix: [],
          function: [],
          upgrade: [
            "Refonte de la plupart des fonctionnalités.",
            "Quality check sur tous les éléments de l'application.",
            "Optimisation générale de l'application.",
            "Accueil : Vérification de l'existence des projets récents affichés.",
          ],
        },
        {
          version: "v1.0.0",
          date: "2022-01-14",
          fix: ["Médiathèque : Correction de bug."],
          function: [
            "Projet : Ajout de la suppression de projet dans la page.",
            "Médiathèque : Ouverture d'un projet lors d'un double clic.",
            "Médiathèque : Prévisualisation d'un fichier image ou vidéo lors d'un double clic.",
            "Profil : Ajout du choix de la ville.",
          ],
          upgrade: ["Création du compte démo."],
        },
        {
          version: "v0.9.9-beta",
          date: "2021-10-21",
          fix: [],
          function: [
            "Ajout d'un système de notification.",
            "Login : Ajout de la sauvegarde des informations de connexion.",
            "Widgets : Ajout des widgets RSS et Météo.",
            "Player : Possibilité de modifier la position et la taille.",
            "Player : Ajout du mode LED.",
          ],
          upgrade: ["Login : Ajout du login automatique lorsque les informations sont sauvegardées."],
        },
      ],
      currentVersion: null,
    };
  },
  created() {
    document.title = this.$t("navbar.changelog") + " · " + this.$t("appname");
    this.$store.dispatch("setHeader", this.$t("navbar.changelog"));

    // Make the first one selected (the last version on first slot)
    this.currentVersion = this.changelog[0];
  },
  methods: {
    formatDate(date) {
      moment.locale(this.$i18n.locale);
      return moment(date, "YYYY-MM-DD").format("dddd DD MMMM YYYY");
    },
  },
};
</script>

<style>
.theme--dark #publish-area {
  background-color: #424242;
}

.theme--light #publish-area {
  background-color: #eeeeee;
}
</style>
